import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Filter } from 'lucide-react';

const SearchSection = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleQuickSearch = (query: string) => {
    navigate(`/search?q=${encodeURIComponent(query)}`);
  };

  const handleAdvancedSearch = () => {
    navigate('/college-reviews');
  };

  return (
    <section className="py-2 py-md-5 bg-white">
      <div className="container">
        <div className="row justify-content-center px-2 px-md-0">
          <div className="col-lg-8 col-md-10">
            <div className="text-center mb-2 mb-md-4">
              <h2 className="h1 fw-bold text-dark mb-3" style={{ fontSize: 'clamp(1.75rem, 5vw, 2.5rem)' }}>
                Search Your Perfect College
              </h2>
              <p className="lead text-muted" style={{ fontSize: 'clamp(1rem, 3vw, 1.25rem)' }}>
                Find colleges by name, course, location, and more
              </p>
            </div>

            <form onSubmit={handleSearch} className="search-form">
              <div className="d-flex flex-column flex-md-row align-items-stretch gap-3">
                <div className="flex-grow-1 position-relative order-1">
                  <Search className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" size={20} />
                  <input
                    type="text"
                    placeholder="Search by College Name, Course, Location..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="form-control form-control-lg border-0 ps-5"
                    style={{ backgroundColor: 'transparent', minHeight: '48px', fontSize: '16px' }}
                  />
                </div>
                <div className="d-flex flex-column flex-sm-row gap-2 order-2">
                  <button
                    type="button"
                    onClick={handleAdvancedSearch}
                    className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2 w-100 w-sm-auto"
                    style={{ minHeight: '48px' }}
                  >
                    <Filter size={16} />
                    <span>Advanced Search</span>
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary px-4 w-100 w-sm-auto"
                    style={{ minHeight: '48px' }}
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>

            {/* Quick Filter Tags */}
            <div className="d-flex flex-wrap justify-content-center gap-2 mt-4 px-2">
              {['JEE Main', 'JEE Advanced', 'NEET', 'CLAT', 'CAT', 'State CET'].map((tag) => (
                <button
                  key={tag}
                  onClick={() => handleQuickSearch(tag)}
                  className="quick-filter-tag border-0"
                  style={{ minHeight: '40px', fontSize: 'clamp(0.8rem, 2.5vw, 0.875rem)' }}
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchSection;